const service = {
  loginAdmin: "admin/loginAdmin",
  loginAdminHistory: "admin/loginAdminHistory",
  userManagement: "admin/userManagement",
  tokenManagement: "admin/tokenManagement",
  issuerManagement: "admin/issuerManagement",
  contactManagement: "admin/contactManagement",
  createuser: "admin/createuser",


  getuserHistoryCSV: "admin/getuserHistoryCSV",
  gettokenHistoryCSV: "admin/gettokenHistoryCSV",
  getissuerHistoryCSV: "admin/getissuerHistoryCSV",
  getcontactHistoryCSV: "admin/getcontactHistoryCSV",


  createToken: "admin/createToken",
  createcontact: "admin/createcontact",
  createIssuer: "admin/createIssuer",
  userCount: "admin/userCount",
  issuerCount: "admin/issuerCount",
  connectwallet: "api/connect",
  getuser: "api/getuser",
  getAllTokens: "api/alltoken",
  getTokenById: "api/gettokenbyId",
  buyTokens: "api/buytoken",
  getUserPortfolio: "api/getportfolio",
  getTransactions: "api/getTransaction",
  sellTokens: "api/selltoken",

};

export default service;
